export const REFETCH_TEMPLATE_ITEMS_MS = 10000;
